import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";

export default function PostHelmet({ post }) {
  const image = post?.image?.url;

  return (
    <Helmet>
      <title>{post.title}</title>

      <meta name="twitter:title" content={post.title} />
      <meta property="og:title" content={post.title} />

      {post.description && (
        <meta name="description" content={post.description} />
      )}

      {post.description && (
        <meta property="og:description" content={post.description} />
      )}
      {post.description && (
        <meta name="twitter:description" content={post.description} />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      {image && <meta property="og:image" content={image} />}
      {image && <link rel="image_src" href={image} />}
      {image && <meta name="twitter:image" content={image} />}
      {image && <meta property="vk:image" content={image} />}
    </Helmet>
  );
}

PostHelmet.propTypes = {
  post: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
};
